import Icon from '../components/Icon.vue'

Icon.register({
  kaaba: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M554.1 83.5L318.4 4.9A96-96 0 0 1 257.7 4.9L21.9 83.5A32-32 0 0 1 0 113.9V162.9L265 83.4C280.1 78.9 295.9 78.9 311 83.4L576 162.9V113.9C576 100.1 567.2 87.9 554.1 83.5zM274.2 114L0 196.3V424.7C0 439.7 10.4 452.7 25.1 455.9L267.2 509.7A95.9-95.9 0 0 1 308.8 509.7L551 455.9C565.6 452.7 576 439.7 576 424.7V196.3L301.8 114C292.8 111.3 283.2 111.3 274.2 114zM128 230.1C128 233.7 125.6 236.9 122.1 237.8L42.1 259.6C37 261 32 257.2 32 251.9V235.3C32 231.7 34.4 228.6 37.9 227.6L117.9 205.8C123 204.4 128 208.3 128 213.5V230.1zM272 190.8C272 194.4 269.6 197.6 266.1 198.6L170.1 224.7C165 226.1 160 222.3 160 217V200.4C160 196.8 162.4 193.7 165.9 192.7L261.9 166.5C267 165.1 272 169 272 174.3V190.8zM448 213.5C448 208.3 453 204.4 458.1 205.8L538.1 227.6C541.6 228.6 544 231.7 544 235.3V251.9C544 257.2 539 261 533.9 259.6L453.9 237.8A8-8 0 0 0 448 230.1V213.5zM304 174.3C304 169 309 165.1 314.1 166.5L410.1 192.7C413.6 193.7 416 196.8 416 200.4V217C416 222.3 411 226.1 405.9 224.7L309.9 198.6A8-8 0 0 0 304 190.8V174.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kaaba.js
// module id = DMID
// module chunks = 144